var FcListItemModule = /** @class */ (function () {
    function FcListItemModule() {
    }
    return FcListItemModule;
}());
export { FcListItemModule };
